import { render, staticRenderFns } from "./ykc-input.vue?vue&type=template&id=4878d68f"
import script from "./ykc-input.vue?vue&type=script&lang=js"
export * from "./ykc-input.vue?vue&type=script&lang=js"
import style0 from "./ykc-input.vue?vue&type=style&index=0&id=4878d68f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports